'use client'
import React from 'react'
import Image from 'next/image'
import { Divider, Card, CardHeader, CardBody, CardFooter, } from '@nextui-org/react'
type Props = {
    title: string
    description: string
    image: string
}
const BasicCard = (props: Props) => {
    return (
        <div className='flex flex-col gap-4 w-full justify-evenly shadow-sm bg-white rounded-lg flex-grow'>
            <Image src={props.image} alt='Types' width={400} height={400} className='w-full rounded-t-lg h-[240px] object-cover object-center' />
            <div className="w-full flex flex-col gap-4 p-4">
                <h2 className='text-xl text-left'>{props.title}</h2>
                <p>{props.description}</p>
            </div>
        </div >
    )
}

export default BasicCard